import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import OtpInput from "../../components/ui/OtpInput";
import { readPortalSession, writePortalSession } from "../../lib/storage/portalSession";
import { verifyOtp } from "../../services/api/portal";
import { normalizeError } from "../../services/http/errors";

export default function PortalVerify() {
  const { portalSlug = "" } = useParams();
  const nav = useNavigate();
  const session = useMemo(() => readPortalSession(), []);
  const [code, setCode] = useState("");
  const [seconds, setSeconds] = useState(45);
  const [toast, setToast] = useState({ open: false, msg: "" });

  useEffect(() => {
    const t = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, []);

  if (!session || session.portalSlug !== portalSlug) {
    return <Navigate to={`/r/${portalSlug}`} replace />;
  }

  const submit = async () => {
    try {
      const result = await verifyOtp(portalSlug, session.orderNumber, session.email, code);
      writePortalSession({ ...session, verified: true, sessionToken: result.session_token ?? null });
      nav(`/r/${portalSlug}/items`);
    } catch (e) {
      const err = normalizeError(e);
      setToast({ open: true, msg: err.message });
    }
  };

  return (
    <>
      <Snackbar open={toast.open} autoHideDuration={3000} onClose={() => setToast({ open: false, msg: "" })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" onClose={() => setToast({ open: false, msg: "" })} variant="filled">
          {toast.msg}
        </Alert>
      </Snackbar>

      <Card sx={{ maxWidth: 480, width: "100%" }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={2} alignItems="center">
            <VerifiedUserOutlinedIcon sx={{ fontSize: 40, color: "primary.main" }} />

            <Typography variant="h5">Verification</Typography>
            <Typography variant="body2" color="text.secondary">
              We sent a 6-digit code to your email
            </Typography>

            <OtpInput length={6} value={code} onChange={setCode} />

            <Button variant="contained" size="large" fullWidth onClick={submit} disabled={code.length !== 6}>
              Verify Identity
            </Button>

            <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ mt: 1 }}>
              RESEND CODE IN {seconds}s
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
